export class LocationFilter {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.type = data.type || null;
    this.subtype = data.subtype || null;
    this.value = data.value || null;
    this.parentValue = data.parent_value || null;
    this.valueDescription = data.value_description || null;
  }
}

export default LocationFilter;
